import { ArrowLeft, ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import ProductCard from "../ProductCard";

const RecommendedProducts = ({ products = [] }) => {
  const [startIndex, setStartIndex] = useState(0);

  useEffect(() => {
    setStartIndex(0);
  }, [products]);
  
  const showNext = () => {
    if (startIndex + 4 < products.length) {
      setStartIndex(startIndex + 1);
    }
  };
  
  const showPrevious = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };
  
  const visibleProducts = products.slice(startIndex, startIndex + 4);
  
  return (
    <div className="relative">
      {visibleProducts.length === 0 ? (
        <div className="text-center text-gray-500 py-8">Nuk ka produkte të rekomanduara.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {visibleProducts.map((product) => {
            const productKey = product.id || product.productCode || product.name;
            return (
              <ProductCard
                key={productKey}
                product={product}
                relatedProducts={products}
              />
            );
          })}
        </div>
      )}
      
      {/* Navigation controls */}
      {startIndex > 0 && visibleProducts.length > 0 && (
        <button
          className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-6 bg-white rounded-full p-2 shadow-md"
          onClick={showPrevious}
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
      )}
      
      {startIndex + 4 < products.length && visibleProducts.length > 0 && (
        <button
          className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-6 bg-white rounded-full p-2 shadow-md"
          onClick={showNext}
        >
          <ArrowRight className="h-5 w-5" />
        </button>
      )}
    </div>
  );
};

export default RecommendedProducts;